import React, { FC } from "react";
import { FormattedMessage } from "react-intl";
import { IButtonProps, Link } from "@fluentui/react";
import { Label } from "cayo.ui";
import { IFormField } from "@cayo/shared/api/types/schema";
import { ObjectLinkContainer } from "./styles";
import SmallSpinner from "../../Utilities/SmallSpinner";

const UnresolvedObjectLink: FC<IFormField & { isLoading?: boolean; commands?: IButtonProps[] }> = ({
  isLoading,
  tooltip,
  label,
  commands,
}) => {
  return (
    <ObjectLinkContainer>
      <Label label={label} tooltip={tooltip} commands={commands} />
      {isLoading ? (
        <SmallSpinner />
      ) : (
        <Link
          disabled={true}
          styles={{
            root: {
              display: "block",
              alignItems: "center",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            },
          }}
        >
          <FormattedMessage id="navlink-notset" defaultMessage="[Not set]" />
        </Link>
      )}
    </ObjectLinkContainer>
  );
};

export default UnresolvedObjectLink;
